// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../../textstyles/fonts.css";
import "../../reset.css";
import "./AvailablePickupTimes.TimesContainer.css";
import React, { createContext, useContext } from "react";
import {
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../../_internal_utils";
import { RootPrimitive, ContainerPrimitive } from "../../_internal_primitives";

const styles = [
  {
    type: "default",
    layers: {
      PdmNuowuAs: {
        none: {
          htmlElement: "main",
        },
      },
    },
  },
  {
    type: "boolean",
    propName: "expanded",
    layers: {},
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "boolean",
    propName: "expanded",
    layers: {},
  },
];

const variantPropTypes = [
  {
    type: "boolean",
    propName: "expanded",
  },
];

export const TimesContainerContext = createContext(null);

function TimesContainer(_props) {
  const defaults = useContext(TimesContainerContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="QERKWfBGDX"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "QERKWfBGDX",
        scope: "Puyyj69JRE",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <ContainerPrimitive
          id={"Container_PdmNuowuAs"}
          className={
            "__visly_reset_7X7HTLRqyD __visly_scope_Puyyj69JRE_PdmNuowuAs"
          }
          key={"PdmNuowuAs"}
          addSpacing={false}
          element={getStyle("PdmNuowuAs", "htmlElement")}
        >
          {
            <ContainerPrimitive
              key={"PLFQc2fwBY"}
              id={"Slot_PLFQc2fwBY"}
              className={
                "__visly_reset_7X7HTLRqyD __visly_scope_Puyyj69JRE_PLFQc2fwBY"
              }
              addSpacing={false}
            >
              {props.children}
            </ContainerPrimitive>
          }
        </ContainerPrimitive>
      )}
    </RootPrimitive>
  );
}

TimesContainer.__variants = [
  {
    name: "expanded",
    type: "variant",
  },
];

export default TimesContainer;
